import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { CitizenshipForeignPassportsTravelModel } from '../types';

export const citizenshipForeignPassportsTravelValidator: ValidateJSModel<CitizenshipForeignPassportsTravelModel> = {
  Country: (value, attributes) => {
    if (attributes.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: true };
  },

  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options.applicantBirthdate), latest: DEFAULT_LATEST },
  }),
};
